import { Box } from '@mui/material'
import React from 'react'

const ArrowEdge = ({sx1}) => {
  return (
    <Box  sx={{ ...sx1 }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M14.8302 11.29L10.5902 7.05001C10.4972 6.95628 10.3866 6.88189 10.2648 6.83112C10.1429 6.78035 10.0122 6.75421 9.88019 6.75421C9.74818 6.75421 9.61747 6.78035 9.49561 6.83112C9.37375 6.88189 9.26315 6.95628 9.17019 7.05001C8.98394 7.23737 8.87939 7.49082 8.87939 7.75501C8.87939 8.0192 8.98394 8.27265 9.17019 8.46001L12.7102 12L9.17019 15.54C8.98394 15.7274 8.87939 15.9808 8.87939 16.245C8.87939 16.5092 8.98394 16.7626 9.17019 16.95C9.26363 17.0427 9.37444 17.116 9.49628 17.1658C9.61812 17.2155 9.74858 17.2408 9.88019 17.24C10.0118 17.2408 10.1423 17.2155 10.2641 17.1658C10.3859 17.116 10.4967 17.0427 10.5902 16.95L14.8302 12.71C14.9239 12.617 14.9983 12.5064 15.0491 12.3846C15.0998 12.2627 15.126 12.132 15.126 12C15.126 11.868 15.0998 11.7373 15.0491 11.6154C14.9983 11.4936 14.9239 11.383 14.8302 11.29Z" fill="#F7F9FC"/>
        </svg>
    </Box>
  )
}

export default ArrowEdge